import React from "react";
import ReactDOM from "react-dom/client";

import { Provider } from "react-redux";
import { applyMiddleware, compose, createStore } from "redux";
import { thunk } from "redux-thunk";

import App from "./App";

import reducer from "./services/redux/reducers";
import reportWebVitals from "./reportWebVitals";

import "./translations/i18n";

import "./assets/styles/styles.scss";

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(reducer, composeEnhancers(applyMiddleware(thunk)));

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
    <Provider store={store}>
        <App />
    </Provider>
);

reportWebVitals();
